var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ml-2 appraisal-autocomplete-input" },
    [
      _c(
        "label",
        {
          staticClass: "d-block font-weight-bold mb-1",
          attrs: { for: "appraisalSearch" },
        },
        [_vm._v("\n        Gutachten suchen\n    ")]
      ),
      _vm._v(" "),
      _c("AutocompleteInput", {
        attrs: {
          id: "appraisalSearch",
          delay: 500,
          "fetch-url": _vm.fetchUrl,
          "map-results": _vm.mapResults,
          "min-length": 3,
        },
        on: { selected: _vm.handleSelected },
        model: {
          value: _vm.searchTerm,
          callback: function ($$v) {
            _vm.searchTerm = $$v
          },
          expression: "searchTerm",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }